import { useTypedSelector } from "../store/reducers/use-typed-selector";
import { BrandliveEvent, FeatureFlagsEnum, PageModule, PageModuleGroupModules, PageModuleType, Session, SessionTabsLayoutTypes, TranslateString } from "../types/working-model";
import { useIsNewNavigation } from "./navigation.hooks";
import { useIsSingleSessionPage } from "./path.hooks";

export const useGetEvent = (): BrandliveEvent | null => {
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const eventBundle = useTypedSelector(state => state.LiveEventReducer.eventBundle);

	return eventBundle || workingEvent;
};
export const useIsSingleSession = (): boolean => {
	const event = useGetEvent();

	return event?.sessions?.length === 1;
};

export const useIsSingleSessionWithoutHome = (): boolean => {
	const showNewNav = useIsNewNavigation();
	const event = useGetEvent();
	const isSingleSessionPage = useIsSingleSessionPage();

	return isSingleSessionPage && showNewNav && !event?.homepage;
};

export const useActiveModulesInGroup = (session: Session | undefined, moduleGroup: PageModuleGroupModules | undefined): PageModule[] => {
	if (!session || !moduleGroup) return [];

	function notSupposedToHaveModules(type: PageModuleType) {
		switch (type) {
			case PageModuleType.description:
			case PageModuleType.questions:
			case PageModuleType.blank:
			case PageModuleType.embed_widget: return true;
			default: return false;
		}
	}

	//If there is no content in the module don't make the tab
	const _modules = session.modules.filter(module => module?.id && moduleGroup.modules.includes(module.id) && module.is_on);
	const modulesWithContent = _modules.filter(_module => notSupposedToHaveModules(_module.type) || !!_module.modules?.length || !!_module.content_modules?.length);

	return modulesWithContent;
};

export const useIsNewModuleGrouping = (): boolean => {
	const featureFlags = useTypedSelector(state => state.FeatureFlagsReducer.featureFlags);
	const event = useGetEvent();


	const isModuleGroupingV2 = event?.settings?.is_module_grouping_v2;
	return !!(featureFlags[FeatureFlagsEnum.session_details_v2] && isModuleGroupingV2);
};

export const useIsAboveTheFold = (session: Session | null | undefined): boolean => {
	return !!(session?.layout?.tabs?.layout === SessionTabsLayoutTypes.AboveTheFold);
};

export const useIsBelowTheFold = (session: Session | null | undefined): boolean => {
	return !!(session?.layout?.tabs?.layout === SessionTabsLayoutTypes.BelowTheFold);
};

export const useGetModuleGroupName = (moduleGroup: PageModuleGroupModules | undefined): string => {
	const moduleGroupName = moduleGroup?.name as TranslateString;
	const _name = moduleGroupName?.base ?? moduleGroupName;

	return _name;
};